module.exports = __webpack_public_path__ + "img/q2.14f070e0.png";